<!-- 
Shows action buttons and tabs for the role page.
-->
<template>
  <div>
    <our-actions-bar 
      :actions="actions"
      @edit="showEditDialog=true" 
      @delete="showDeleteDialog=true"
    />
    <v-card class="home">
      <v-tabs slider-color="primary" show-arrows>
        <v-tab key="summary" :to="getUrl('summary')">
          Summary
        </v-tab>
        <v-tab key="history" :to="getUrl('history')">
          History
        </v-tab>
      </v-tabs>
      <slot/>
    </v-card>
    <role-edit-dialog v-model="showEditDialog" :role-id="roleId" />
    <role-delete-dialog v-model="showDeleteDialog" :role-id="roleId" @changed="$router.push('/roles')"/>
  </div>
</template>

<script>
import RoleEditDialog from "@/components/roles/RoleEditDialog.vue";
import RoleDeleteDialog from "@/components/roles/RoleDeleteDialog.vue";
import * as claim from "@/store/claim-types";

export default {
  components: { RoleEditDialog, RoleDeleteDialog },
  props: {
    roleId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      showDeleteDialog: false,
      showEditDialog: false
    };
  },
  computed: {
    actions() {
      return this.canEdit
        ? [
            { icon: "edit", text: "Edit", description: "Edit this role and its permissions.", emit: "edit" },
            { icon: "delete", text: "Delete", description: "Delete this role.", emit: "delete" }
          ]
        : [];
    },
    canEdit() {
      return this.$store.getters.claims.includes(claim.ROLES_EDIT);
    }
  },
  methods: {
    getUrl(suffix) {
      return `/roles/${this.roleId}/${suffix}`;
    }
  }
};
</script>
